import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {Helper} from "../../../../containers/AppPage/Reports/Ledger/helper";
import {AmountTdWidth} from "../../../Table/Common/AmountTd";

function getColumns(props) {
    const {companyCurrencyCode} = props;
    return [
        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDate,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber,
        },
        {
            key: 'type',
            dataKey: 'type',
            title: t`Type`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderType,
        },
        {
            key: 'number2',
            dataKey: 'number2',
            title: t`Reference No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber2,
        },
        {
            key: 'contact_name',
            dataKey: 'contact_name',
            title: t`Contact`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderContact,
        },
        {
            key: 'contact_code',
            dataKey: 'contact_code',
            title: t`Contact Code`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderContactCode,
        },
        {
            key: 'contact2_name',
            dataKey: 'contact2_name',
            title: t`Contact 2`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderContact2,
        },
        {
            key: 'contact2_code',
            dataKey: 'contact2_code',
            title: t`Contact 2 Code`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderContact2Code,
        },
        {
            key: 'tag_names',
            dataKey: 'tag_names',
            title: t`Tags`,
            ellipsis: true,
            width: 150,
            cellRenderer: Helper.renderTags,
        },
        {
            key: 'currency_code',
            dataKey: 'currency_code',
            title: t`Currency`,
            width: 100,
            cellRenderer: Helper.renderCurrencyCode,
        },
        {
            key: 'exchange_rate',
            dataKey: 'exchange_rate',
            title: t`Exchange Rate`,
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: Helper.renderExchangeRate,
        },
        {
            key: 'description',
            dataKey: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 17,
            cellRenderer: Helper.renderDescription,
        },
        {
            key: 'debit_amount',
            dataKey: 'debit_amount',
            title: t`Debit`,
            align: 'right',
            width: AmountTdWidth,
            // flexGrow: 14,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.debit_amount, rowData.currency_symbol,
            ),
        },
        {
            key: 'base_debit_amount',
            dataKey: 'base_debit_amount',
            title: companyCurrencyCode ? t`Debit ${companyCurrencyCode}` : t`Home Debit`,
            align: 'right',
            width: AmountTdWidth,
            // flexGrow: 14,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.base_debit_amount, rowData.base_currency_symbol,
            ),
        },
        {
            key: 'credit_amount',
            dataKey: 'credit_amount',
            title: t`Credit`,
            align: 'right',
            width: AmountTdWidth,
            // flexGrow: 14,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.credit_amount, rowData.currency_symbol,
            ),
        },
        {
            key: 'base_credit_amount',
            dataKey: 'base_credit_amount',
            title: companyCurrencyCode ? t`Credit ${companyCurrencyCode}` : t`Home Credit`,
            align: 'right',
            width: AmountTdWidth,
            // flexGrow: 14,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.base_credit_amount, rowData.base_currency_symbol,
            ),
        },
        {
            key: 'amount',
            dataKey: 'amount',
            title: t`Amount`,
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.amount, rowData.currency_symbol,
            ),
        },
        {
            key: 'base_amount',
            dataKey: 'base_amount',
            title: companyCurrencyCode ? t`Amount ${companyCurrencyCode}` : t`Home Amount`,
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.base_amount, rowData.base_currency_symbol,
            ),
        },
        {
            key: 'balance_amount',
            dataKey: 'balance_amount',
            title: t`Balance`,
            align: 'right',
            width: AmountTdWidth + 5,
            cellRenderer: ({ rowData }) => {
                if (String(rowData.key)?.includes('opening_')) {
                    return Helper.renderAmount(
                        rowData.balance_amount, rowData.total_currency_symbol,
                    );
                }

                if (String(rowData.key)?.includes('unrealized_')) {
                    return Helper.renderAmount(
                        rowData.balance_amount, rowData.base_currency_symbol,
                    );
                }

                return Helper.renderAmount(
                    rowData.balance_amount, rowData.currency_symbol,
                );
            },
        },
        {
            key: 'base_balance_amount',
            dataKey: 'base_balance_amount',
            title: companyCurrencyCode ? t`Balance ${companyCurrencyCode}` : t`Home Balance`,
            align: 'right',
            width: AmountTdWidth + 5,
            cellRenderer: ({ rowData }) => Helper.renderAmount(
                rowData.base_balance_amount, rowData.base_currency_symbol,
            ),
        },
        {
            key: 'created_at',
            dataKey: 'created_at',
            title: t`Created At`,
            // width: AmountTdWidth,
            width: 0,
            flexGrow: 20,
            cellRenderer: Helper.renderCreatedAt,
        },
    ];
}

export default {
    storageKey: StorageKey.report_general_ledger,
    getReportLabel: () => t`General Ledger`,
    required: [
        'date',
        'number',
    ],
    defaulto: [
        'contact_name',
        'description',
        'base_debit_amount',
        'base_credit_amount',
        'base_balance_amount',
    ],
    getColumns,
};
